export default __webpack_public_path__ + "static/media/Group.e621ce53.png";